/**
 * AdminRoute — route guard for all protected admin pages.
 * Unauthenticated → /login
 * Authenticated but not admin (shouldn't happen, but safe) → /login
 * Authenticated but wrong role → Access Denied screen
 *
 * Props:
 *   roles — optional array of allowed admin_role values.
 *           If omitted, any admin can access the route.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';

const AccessDenied = () => (
  <div style={{
    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
    minHeight: '100vh', background: '#f5f7fa', fontFamily: 'Inter, sans-serif',
    textAlign: 'center', padding: 40,
  }}>
    <div style={{ fontSize: 56, marginBottom: 16 }}>🚫</div>
    <h1 style={{ fontSize: 24, color: '#1e293b', margin: 0, marginBottom: 8 }}>Access Denied</h1>
    <p style={{ color: '#64748b', fontSize: 15, maxWidth: 360, lineHeight: 1.5 }}>
      You don't have permission to view this page. Contact the Super Admin if you believe this is an error.
    </p>
    <a href="/" style={{
      marginTop: 20, padding: '10px 24px', borderRadius: 10,
      background: '#6366f1', color: '#fff', textDecoration: 'none',
      fontSize: 14, fontWeight: 600,
    }}>
      Go to Dashboard
    </a>
  </div>
);

const AdminRoute = ({ children, roles }) => {
  const { isAuthenticated, admin, loading, hasRole } = useAdminAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        minHeight: '100vh', background: '#f5f7fa', color: '#64748b',
        fontSize: '16px', fontFamily: 'Inter, sans-serif',
      }}>
        <span>Loading…</span>
      </div>
    );
  }

  if (!isAuthenticated || admin?.user_type !== 'admin') {
    return <Navigate to="/login" replace />;
  }

  // If specific roles are required, check them
  if (roles && roles.length > 0 && !hasRole(...roles)) {
    return <AccessDenied />;
  }

  return children;
};

export default AdminRoute;
